import { Controller } from "@hotwired/stimulus"

// Generic form change tracker
// Highlights fields that differ from their original values
//
// Usage:
//   <form data-controller="form-tracker">
//     <input data-form-tracker-target="field" data-action="input->form-tracker#check change->form-tracker#check">
//     <select data-form-tracker-target="field" data-action="change->form-tracker#check">
//   </form>
//
export default class extends Controller {
  static targets = ["field"]

  static values = {
    highlightColor: { type: String, default: '#fffde7' }
  }

  connect() {
    this.originalValues = new Map()
    this.fieldTargets.forEach(el => {
      this.originalValues.set(el, el.value)
    })
  }

  check() {
    this.fieldTargets.forEach(el => {
      const original = this.originalValues.get(el)
      if (el.value !== original) {
        el.style.backgroundColor = this.highlightColorValue
      } else {
        el.style.backgroundColor = ''
      }
    })
  }
}
